module.exports = __webpack_public_path__ + "media/images/pages/img_close_profile_default-550623fb8542a55e180c6da8ebce27a0.png";